module.exports = __webpack_public_path__ + "img/light-bulb.f19af9dc.svg";